/* eslint-disable */
class Html5 {

  constructor(container){

    this.container = container;

    this.video = this.container.querySelector('video');

    this.play = this.play.bind(this);
    this.stop = this.stop.bind(this);
    this.handleEvents = this.handleEvents.bind(this);
    this.init = this.init.bind(this);
    
    if(this.video != null){
      this.init();
      this.handleEvents();  
    }

  }

  init() {

  }

  handleEvents() {

    this.video.addEventListener('ended',() => {

      // self.carousel.carousel('next');
      this.container.dispatchEvent(new CustomEvent('docarouselnext', {
        bubbles: true,
      }));

    });


  }

  play() {
    if( this.video == null ){
      return;
    }
    this.video.play();
  }

  stop() {

    if( this.video == null ){
      return;
    }

    this.video.pause();
    this.video.currentTime = 0;
  }

}

export default Html5;



// WEBPACK FOOTER //
// ./scripts/classes/videoplayer/html5.js